import axios from 'axios'
import sessionstorage from '@/components/cache'
import getIP from '@/components/utils/getIP'
import baseUrl from '@/assets/js/baseUrl'
import router from '../../router'
const downloadUrl = url => {
  let iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    document.body.removeChild(iframe)
  }
  document.body.appendChild(iframe)
}
let lock = false
// 请求时的拦截
axios.interceptors.request.use(function (config) {
  // showFullScreenLoading(config)
  // 发送请求之前做一些处理
  return config
}, function (error) {
  // 当请求异常时做一些处理
  return Promise.reject(error)
})
// 响应时拦截
axios.interceptors.response.use(function (res) {
  if (res.headers && (res.headers['content-type'] === 'application/x-msdownload' || res.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || res.headers['content-type'] === 'application/zip')) {
    downloadUrl(res.request.responseURL)
    return
  }
  return res
}, function (error) {
  if (lock) return
  switch (error.response.status) {
    case 404:
      // 404处理
      break
    case 500:
      // 500处理
      break
    case 401:
     if(!lock) {
        // router.push({path: '/', query: {redirectPath: window.location.href.split('?')[0], errorMsg: '用户已失效，请重新登录'}})
        // window.location.href = window.location.href.split('#')[0] + '#/?redirectPath=' + window.location.href.split('?')[0] + '&errorMsg=信息已过期，请重新登录'
        alert('登录状态失效,请重新登录')
        var homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
        window.location.href = 'https://sso.ihasl.com/GETST?service=' + encodeURIComponent(baseUrl.loginBack + encodeURIComponent(homePage + baseUrl.address)) + '&loginUrl=' + encodeURIComponent(homePage + '/pages/salessupport/pc/index.html')
        lock = true
      }
      break
    default:
      break
  }
  if (error.response.status !== 401) {
    alert('接口调用失败:' + error.response.statusText + '\n' +
      '状态码:' + error.response.status)
    // 当响应异常时做一些处理
    return Promise.reject(error.response.response)
  }
})
// axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.BASEURL_ROOT
export default {
  get (url, options) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        params: options,
        timeout: 60 * 1000, // 30秒超时
        headers: {
          'Content-Type': 'application/json'
          // 'sid': sessionStorage.getItem('sid')
        }
      }).then(function (response) {
        resolve(response)
      }).catch(function (error) {
        if (error) {
          reject(new Error('接口调用失败'))
        }
      })
    })
  },
  post(url, options) {
    let index = url.indexOf('huize')
    if (index != -1) {
      axios.defaults.baseURL = process.env.BASEURL_ROOT_HUIZE
    } else {
      axios.defaults.baseURL = process.env.BASEURL_ROOT
    }
    return new Promise((resolve, reject) => {
      options.systemType = '2'
      // var name = 'jtl'
      // var arr
      // var token = ''
      // var username = ''
      // var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
      // if ((arr = document.cookie.match(reg))) {
      //   token = arr[2]
      // }
      // 获取当前时区偏移量
      var localOffset = -(new Date().getTimezoneOffset() * 60000)
      // 获取浏览器IP
      var agent = getIP.getBrowserInfo()

      // token = 'eyJhbGciOiJIUzI1NiJ9.eyJ0Z3QiOiJkMjNlMzBmNWE0YTk0ZjgwYmY2YzllMzM5YmY4MzNiOCIsInN1YiI6IjYyMDAxNTU0IiwiZXhwIjoxNTM5MTE0NDA5LCJ1c2VyaWQiOiI2MjAwMTU1NCIsImlhdCI6MTUzOTA3MTIwOSwia2V5IjoiZDIzZTMwZjVhNGE5NGY4MGJmNmM5ZTMzOWJmODMzYjgtUkVEIn0.gs2M85_2iED21KTdxcHVE0wK2dQ3aG0TNvVNTvyH3P4'
      // 本地测试
      var token = sessionstorage.session_get('token')
      var username = sessionstorage.session_get('username')

      axios({
        method: 'post',
        url,
        data: options,
        // withCredentials: true,
        timeout: 60 * 1000, // 30秒超时
        // headers: options.header || {'Content-Type': 'application/json'}
        headers: {
          'Content-Type': 'application/json',
          'ComId': 'ebiz-agent',
          'Authorization': 'Basic ' + token,
          'Accept-Device': 'NULL',
          'Accept-DeviceOS': getIP.getVersion(),
          'Accept-Location': 'NULL',
          'Accept-ISP': 'NULL',
          'Accept-StartTime': 'NULL',
          'Accept-TimeZone': localOffset,
          'Accept-Attr1': agent,
          'Accept-Attr2': 'PC',
          'Accept-Attr3': '',
          'Real-Ip': agent,
          'Accept-Attr4': 'NULL',
          'Accept-Attr6': username
        }
      }).then(response => {
        resolve(JSON.parse(response.data))
      }).catch(error => {
        if (error) {
          reject(new Error('接口调用失败'))
        }
      })
    })
  },
  postUpload (url, options) {
    return new Promise((resolve, reject) => {
      options.systemType = '2'
      axios({
        method: 'post',
        url,
        data: options,
        timeout: 30 * 1000, // 30秒超时
        // headers: options.header || {'Content-Type': 'application/json'}
        headers: {
          'Content-Type': 'application/json',
          'ComId': 'ebiz-agent',
          'Authorization': 'Basic ' + sessionstorage.session_get('token')
        // 'Authorization': 'Bearer ' +  'eyJhbGciOiJIUzI1NiJ9.eyJ0Z3QiOiJjNjgwMWUxNDdkNTY0ZmJkOGU3NWE3NDc2OTYwNTcwYSIsInN1YiI6IlBFMDU1NiIsImV4cCI6MTUzODE2MjI0MCwidXNlcmlkIjoiUEUwNTU2IiwiaWF0IjoxNTM4MTE5MDQwLCJrZXkiOiJjNjgwMWUxNDdkNTY0ZmJkOGU3NWE3NDc2OTYwNTcwYS1SRUQifQ.mhng3vQ6CM4KFdU1L4cbWc5shBjU0bWrUORyRkdj6ng'
        }
      }).then(response => {
        resolve(response.data)
      }).catch(error => {
        if (error) {
          reject(new Error('接口调用失败'))
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/axiost.js